import { Component, OnInit } from '@angular/core';
import { IPlant } from 'src/app/interfaces/plant';
import { PlantService } from 'src/app/services/plant.service';
import {Response} from "../../interfaces/response";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { BootstrapContentModalComponent } from '../bootstrap-content-modal/bootstrap-content-modal.component'
import { PlantSaveComponent } from './plant-save/plant-save.component'

@Component({
  selector: 'app-plants',
  templateUrl: './plants.component.html',
  styleUrls: ['./plants.component.css']
})
export class PlantsComponent implements OnInit {

  texto: string;
  plants: IPlant[];
  lastPage: number;

  constructor(
    private plantService: PlantService,
    private ngbModalRef: NgbModal
    ) { }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(currentPage = 1) {
    this.plantService.all(currentPage).subscribe(
      (res: Response) => {
        this.plants = res.data;
        this.lastPage = res.meta.last_page;
      }
    )
  }

  delete(id: number) {
    if (confirm('Are you sure you want to delete this record?')) {
      this.plantService.delete(id).subscribe(
        res => {
          this.plants = this.plants.filter(el => el.id !== id);
        }
      );
    }
  }

  mostrarBootstrapModal(id: number,tipo: string) {
    const opts = {
      windowClass: 'myCustomClass'
    };
//
    const modalRefNgBots = this.ngbModalRef.open(PlantSaveComponent, opts);
//
    modalRefNgBots.componentInstance.id = id;
    modalRefNgBots.componentInstance.tipo = tipo;
//
    modalRefNgBots.componentInstance.closeMyModal = () => {
      modalRefNgBots.close();
    }
//
    modalRefNgBots.componentInstance.salida.subscribe(res => {

     // this.texto = res;
      console.log('Recibo: ', res.success);
      if (res.success){
        alert("Grabado");
      }
      this.refresh();
      modalRefNgBots.close();
    });

  }

}
